import { EmptyState, Paragraph1 } from 'inpock-ui-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Paragraph2 } from 'inpock-ui-react';

import { MarketProduct, MarketTab, Skeleton } from '@/components';
import { MarketProduct as MarketProductType } from '@/apis';

import * as S from './styled';

interface ForSaleCampaignsProps {
  products: MarketProductType[];
  loading?: boolean;
  marketId: number;
  version?: string;
}

interface AllCampaignProps {
  categories: string[];
  onClickTab: (category: string) => void;
  activeCategory?: string;
  products: MarketProductType[];
  currentPage: number;
  totalPage: number;
  onClickShowMore?: () => void;
  loading: {
    market: boolean;
    products: boolean;
  };
  marketId: number;
  version?: string;
}

function ForSaleCampaignsSkeleton() {
  return (
    <>
      <Skeleton width={90} height={18} />
      <S.SkeletonProductsGrid>
        {Array.from({ length: 3 }).map((_, index) => (
          <S.SkeletonProduct key={index}>
            <Skeleton width={'100%'} height={140} className="image" />
            <Skeleton width={'100%'} height={36} className="title" />
            <Skeleton width={'100%'} height={58} className="info" />
            <Skeleton width={'50%'} height={14} />
          </S.SkeletonProduct>
        ))}
      </S.SkeletonProductsGrid>
    </>
  );
}

function ForSaleCampaigns({ products, loading, marketId, version }: ForSaleCampaignsProps) {
  if (!products || !products.length) return <></>;

  if (loading) return <ForSaleCampaignsSkeleton />;

  return (
    <>
      <div className="section-title">
        <Paragraph1>판매중인 상품</Paragraph1>
      </div>
      <Swiper spaceBetween={10} slidesPerView={2.2}>
        {products.map((campaign, index) => (
          <SwiperSlide key={index}>
            <MarketProduct campaign={campaign} marketId={marketId} version={version} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

function AllCampaignsSkeleton() {
  return (
    <>
      <S.SkeletonAllProductsGrid>
        {Array.from({ length: 2 }).map((_, index) => (
          <S.SkeletonAllProduct key={index}>
            <Skeleton width={'100%'} height={170} className="image" />
            <Skeleton width={'100%'} height={36} className="title" />
            <Skeleton width={'100%'} height={58} className="info" />
            <Skeleton width={'45%'} height={14} />
          </S.SkeletonAllProduct>
        ))}
      </S.SkeletonAllProductsGrid>
    </>
  );
}

function AllProducts({
  categories,
  onClickTab,
  activeCategory,
  products,
  currentPage,
  totalPage,
  onClickShowMore,
  loading,
  marketId,
  version,
}: AllCampaignProps) {
  const { market: marketLoading, products: productsLoading } = loading;

  return (
    <>
      {marketLoading ? (
        <Skeleton width={56} height={18} />
      ) : (
        <MarketTab tabs={categories} onClick={onClickTab} activeTab={activeCategory} />
      )}
      {productsLoading ? (
        <AllCampaignsSkeleton />
      ) : products.length ? (
        <>
          <S.AllProductContainer>
            {products.map((campaign, index) => (
              <MarketProduct
                key={index}
                campaign={campaign}
                marketId={marketId}
                version={version}
              />
            ))}
          </S.AllProductContainer>
          {currentPage < totalPage && (
            <S.ShowMoreButton onClick={onClickShowMore}>
              <Paragraph2 className="text-gray-600">
                더보기 ({currentPage}/{totalPage})
              </Paragraph2>
            </S.ShowMoreButton>
          )}
        </>
      ) : (
        <EmptyState height={140} className="mt-20" emojii="🛒" subText="판매중인 상품이 없습니다" />
      )}
    </>
  );
}

export const MarketCampaigns = Object.assign({
  ForSale: ForSaleCampaigns,
  All: AllProducts,
});
